import { Component, ElementRef, EventEmitter, Output, ViewChild, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompetenciesService } from '../../competencies.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
export interface Partnership {
  logo: string;
  name: string;
  type: string;
  description: string;
  id: string;
  partnershipLogo: string;
  sharepointId: string;
}
@Component({
  selector: 'app-partnership-creation-component',
  templateUrl: './partnership-creation-component.component.html',
  styleUrls: ['./partnership-creation-component.component.css']
})
export class PartnershipCreationComponentComponent implements AfterViewInit {
  @Output() partnershipAdded: EventEmitter<Partnership> = new EventEmitter<Partnership>();
  public selectedLogoFile: any = [];
  selectedFileNames: string[] = [];
  partnershipsList: Partnership[] = [];

  isEditMode: boolean = false;
  logobase64: string | null = null;
  public loading = false;
  a: any = null;
  flag: any;
  isFilechange: boolean = false;
  public receivedData: Partnership;
  @ViewChild('file', { static: false }) fileInput: ElementRef<HTMLInputElement>;
  @ViewChild('input1') inputField1: ElementRef;
  @ViewChild('input2') inputField2: ElementRef;
  @ViewChild('input3') inputField3: ElementRef;
  @ViewChild('input4') inputField4: ElementRef;
  formData = new UntypedFormGroup({
    Logo: new UntypedFormControl('', Validators.required),
    Name: new UntypedFormControl('', Validators.required),
    Type: new UntypedFormControl('', Validators.required),
    Description: new UntypedFormControl('', Validators.required),

  });
  constructor(private dialogRef: MatDialogRef<PartnershipCreationComponentComponent>,
    private compt: CompetenciesService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: Partnership) { }

  ngAfterViewInit(): void {
    this.isEditMode = !this.data;
    if (this.data) {
      this.receivedData = this.data;
    }
    if (this.receivedData) {
   
      this.formData.controls['Name'].setValue(this.receivedData.name, { onlySelf: true });
      this.formData.controls['Type'].setValue(this.receivedData.type, { onlySelf: true });
      this.formData.controls['Description'].setValue(this.receivedData.description, { onlySelf: true });
      this.selectedLogoFile.push({ name: this.receivedData.logo, logo: this.receivedData.partnershipLogo });
      this.selectedLogoFile = this.selectedLogoFile[0];
      this.formData.controls['Logo'].setValue(this.selectedLogoFile.name, { onlySelf: true });

    }
  }


  onLogoFileChange(files: FileList | null): void {

    if (files && files.length > 0) {
      this.selectedLogoFile = files[0];
    }
    var x = Array.from(files);
    x = [...new Set(x)];
    x.forEach(async (element: File) => {
      if (this.isFileSelected(element)) {
        this.toastr.warning("This file is already selected.")
        return;
      }
    
      let processedFile = await Promise.resolve(this.convertFile(element))
     
      const extension = element.name.split('.').pop()
      let extensionTypes = ['.png', '.jpg', '.jpeg', '.svg']
      
      if (extension != 'png' && extension != 'jpg' && extension != 'jpeg' && extension != 'svg') {

        return;
      }
      else {
      }

      this.flag = true
      this.isFilechange=true;
      this.addSelectedFile(element);
    });
    if (this.flag)
      
      this.a = this.formData.getRawValue()
  }
  isFileSelected(file: File): boolean {
    if (this.selectedFileNames.includes(file.name)) {
      return true;
    }
    return false;
  }
  addSelectedFile(file: File): void {
    this.selectedFileNames.push(file.name);
  }
  convertFile(file) {
   
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    })
  }
  async onSubmit() {
   
    this.flag = true;
    this.loading = true;
    this.a = this.formData.getRawValue()
   
    if (!(this.a.Logo && this.a.Name && this.a.Type
      && this.a.Description)) {

      return;
    }
    if (this.flag && this.isFilechange) {
      
      let processedFile = await Promise.resolve(this.convertFile(this.selectedLogoFile));
      this.a.Logo = this.selectedLogoFile.name
      this.a.partnershipLogo = processedFile.toString().split(",")[1]
    }
    else {
      this.a.Logo = this.selectedLogoFile.name
      this.a.partnershipLogo = this.selectedLogoFile.logo
    }
   
    const editedPartnership: Partnership = {
     
      id: (this.receivedData && this.receivedData.id),
      
      logo: this.a.Logo,
      name: this.inputField2.nativeElement.value,
      type: this.inputField3.nativeElement.value,
      description: this.inputField4.nativeElement.value,
      partnershipLogo: this.a.partnershipLogo,
      sharepointId: ''
    };
    this.compt.postPartnershipdetails(editedPartnership).subscribe((response) => {
      this.dialogRef.close(editedPartnership);
      this.toastr.success("Partnership added Successfully");
      this.partnershipsList.push(editedPartnership);
    }, error => {

      console.error('Error editing record:', error);
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
